import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  Typography,
  Snackbar,
  Paper,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Alert } from '@material-ui/lab';

import {
  selectCardList,
  getPaymentCardSessionsByStatus,
} from '../store/widgetSlice';

import {
  clearMessage,
  selectMessage,
  selectSeverity,
} from '../store/authSlice';

import CardEditor from '../components/common/CardEditor';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default function CardReviewRegular() {
  const { type } = useParams();
  const dispatch = useDispatch();
  const classes = useStyles();
  const cards = useSelector(selectCardList);
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);

  useEffect(() => {
    dispatch(getPaymentCardSessionsByStatus({ statusCode: (type === 'admin') ? 'A' : 'R' }));
  }, [dispatch, type]);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  return (
    <>
      <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>{message}</Alert>
      </Snackbar>
      <Paper className={classes.root}>
        <Typography align="center" component="p" variant="body">
          { `${(cards && cards.length) || 0} cards remaining` }
        </Typography>
        { cards && cards.length > 0 && <CardEditor admin={type === 'admin'} card={cards[0]} /> }
        { (!cards || (cards && cards.length === 0)) && (
          <div className="clear-message__container">
            <div className="clear-message__inner-container">
              <h2 className="clear-message__title">Queue is clear!</h2>
              <p className="clear-message__text">You may now close this window and check back later.</p>
            </div>
          </div>
        ) }
      </Paper>
    </>
  );
}
